import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type TagDataFragment = { tagId: string, type?: Types.TagTypeEnum | null, optionIdValues?: Array<string> | null, numberValue?: number | null, textValue?: string | null, isEditable?: boolean | null, options?: Array<{ id: string, name: string }> | null, users?: Array<{ id: string, name?: string | null, profilePicture?: string | null }> | null, dateValue?: { startTime?: string | null, endTime?: string | null } | null };


export type TagDataFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const TagDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TagData on EntityTagType {
  tagId
  type
  options {
    id
    name
  }
  optionIdValues
  users {
    id
    name
    profilePicture
  }
  numberValue
  textValue
  dateValue {
    startTime
    endTime
  }
  isEditable
}
    `;